import { NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

import { IconName } from '../../icons-container/icons.type';
import { AvatarComponent } from '../avatar/avatar.component';
import { AvatarSize } from '../avatar/avatar.types';
import { HeadingComponent } from '../heading/heading.component';
import { IconColorDirective } from '../icon/directives/icon-color.directive';

export type ProviderStatus =
  | string
  | 'connected'
  | 'pending'
  | 'disconnected'
  | 'inactive'
  | 'initial';

@Component({
  selector: 'rt-provider-item',
  templateUrl: './provider-item.component.html',
  styleUrls: ['./provider-item.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgTemplateOutlet, AvatarComponent, HeadingComponent, IconColorDirective],
})
export class ProviderItemComponent {
  @Input() public header: string;
  @Input() public headerTpl: TemplateRef<any>;
  @Input() public description: string | null;
  @Input() public descriptionTpl: TemplateRef<any>;
  @Input() public icon: IconName;
  @Input() public imageSrc: string | null;
  @Input() public iconSize: AvatarSize = 'base';
  @Input() public status: ProviderStatus;
  @Input() public initials: string;
}
